import { API, Auth, graphqlOperation } from 'aws-amplify';
import { getMessaging, getToken } from 'firebase/messaging';
import awsExports from '../../aws-exports';
import {
  createDeviceToken,
  createUser,
  updateUser,
  createUserWest,
} from '../../graphql/mutations';
import { getMerchantUser, getS3SignedURL } from '../../graphql/queries';
import { graphql } from '../../utils/api';
import rolesAuth from '../roles_auth.json';

const authStore = {
  state: {
    loaded: false,
    error: false,
    cognitoUser: null,
    profileImage: null,
    user: null,
    accessModules: null,
    serviceableStores: null,
  },
  reducers: {
    SET_ERROR(state, payload) {
      return {
        ...state,
        error: payload,
        loaded: true,
      };
    },
    SET_USER(state, payload) {
      return {
        ...state,
        cognitoUser: payload.cognitoUser,
        profileImage: payload.profileImage || null,
        user: payload.user || null,
        loaded: true,
      };
    },
    SET_PROFILEIMAGE(state, payload) {
      return {
        ...state,
        profileImage: payload.profileImage || null,
        loaded: true,
      };
    },
    SET_ACCOUNT_CREATED(state, payload) {
      return {
        ...state,
        accountCreated: payload,
      };
    },
    SET_ACCESS_MODULES(state, payload) {
      return {
        ...state,
        accessModules: payload,
      };
    },
    SET_SERVICEABLE_STORES(state, payload) {
      return {
        ...state,
        serviceableStores: payload,
      };
    },
  },
  effects: (dispatch) => ({
    setUser(payload) {
      dispatch.auth.SET_USER(payload);
    },
    setProfileImageUrl(payload) {
      dispatch.auth.SET_PROFILEIMAGE(payload);
    },
    async onBoardUser(name, rootState) {
      const alreadyExistingUser = rootState?.auth?.user;

      const cognitoUserObj = await Auth.currentAuthenticatedUser();
      if (!alreadyExistingUser) {
        await API.graphql(
          graphqlOperation(createUser, {
            input: {
              userId: cognitoUserObj.username,
              firstName: name,
              email: cognitoUserObj.attributes.email,
              userRole: 'M_ADMIN',
            },
          }),
        );
      } else {
        await API.graphql(
          graphqlOperation(updateUser, {
            input: {
              userId: cognitoUserObj.username,
              firstName: name,
            },
          }),
        );
      }
      await this.fetchAndSetUser();
    },
    async fetchAndSetUser() {
      try {
        const cognitoUserObj = await Auth.currentAuthenticatedUser();

        // console.log(
        //   'fetchAndSetUser',
        //   cognitoUserObj.signInUserSession.idToken.payload.m_auth,
        // );

        const dbUser = await API.graphql(
          graphqlOperation(getMerchantUser, {
            userId: cognitoUserObj.username,
          }),
        );
        let s3SignedURL = '';
        const userObj = dbUser?.data?.getMerchantUser;

        // Get access details based on the role.
        const rolesAuthList = rolesAuth;
        const roleAccess = rolesAuthList.find(
          (r) => r.role === userObj.userRole,
        );

        // const roleAccess = rolesAuthList.find(r => r.role === 'Store_Cashier');
        const accessModules = roleAccess?.authorization;
        dispatch.auth.SET_ACCESS_MODULES(accessModules);

        const stores = userObj?.merchantAccount?.Stores;
        dispatch.auth.SET_SERVICEABLE_STORES(stores);

        const messaging = getMessaging();
        getToken(messaging, {
          vapidKey: awsExports.firebase_vapidKey,
        })
          .then((fcmToken) => {
            const CreateDeviceTokenInput = {
              deviceToken: fcmToken,
              userId: userObj?.userId,
              userPool: 'Merchant',
              userType: 'SignedIn',
            };

            const graphqlQueryProduct = graphqlOperation(createDeviceToken, {
              input: CreateDeviceTokenInput,
            });

            graphql({
              ...graphqlQueryProduct,
              authMode: 'API_KEY',
              authToken: awsExports.aws_appsync_apiKey,
            })
              .then((res) => {
                // console.log('Device token saved successfully', res);
              })
              .catch((err) => {
                // console.log('Error while saving device token', err);
              });
          })
          .catch((err) => {
            // console.log('Error getToken for firebase', err);
          });

        dispatch.auth.SET_USER({
          user: userObj,
          profileImage: s3SignedURL,
          cognitoUser: {
            username: cognitoUserObj.username,
            attributes: cognitoUserObj.attributes,
          },
        });

        if (userObj?.profileImage) {
          const r = await API.graphql(
            graphqlOperation(getS3SignedURL, {
              contentType: 'image/jpeg',
              fileName: userObj?.profileImage,
              merchantAccountId: userObj?.merchantAccount?.id,
              requestType: 'get',
            }),
          );

          if (r.data?.getS3SignedURL?.signedURL) {
            s3SignedURL = r.data?.getS3SignedURL?.signedURL;
            dispatch.auth.SET_PROFILEIMAGE({
              profileImage: s3SignedURL,
            });
          }
        }

        return userObj;
      } catch (error) {
        dispatch.auth.SET_ERROR(true);
        throw error;
      }
    },

    async updateServiceableStores() {
      const cognitoUserObj = await Auth.currentAuthenticatedUser();
      const dbUser = await API.graphql(
        graphqlOperation(getMerchantUser, {
          userId: cognitoUserObj.username,
        }),
      );
      const userObj = dbUser?.data?.getMerchantUser;
      const stores = userObj?.merchantAccount?.Stores;
      dispatch.auth.SET_SERVICEABLE_STORES(stores);
    },

    async signup(payload) {
      const {
        email,
        phone_number,
        given_name,
        family_name,
        middle_name,
        username,
        password,
      } = payload;

      const res = await Auth.signUp({
        attributes: {
          email,
          phone_number,
          given_name,
          middle_name,
          family_name,
        },
        username,
        password,
      });

      const createUserWestResp = graphqlOperation(createUserWest, {
        input: {
          email,
          firstName: given_name,
          middleName: middle_name,
          lastName: family_name,
          password,
          phoneNumber: phone_number,
          username,
        },
      });
      API.graphql({
        ...createUserWestResp,
        authMode: 'API_KEY',
        authToken: awsExports.aws_appsync_apiKey,
      });
      return res;
    },
  }),
};

export default authStore;
